// Listes d'options fixes partagées par les formulaires LM pour les champs
// convertis en SelectOuAutre.js — un seul point de vérité pour éviter les
// incohérences entre les ~10 formulaires qui répètent ces mêmes options.

export const FORME_SOCIALE_OPTIONS = [
  { value: "EI", label: "EI" },
  { value: "EIRL", label: "EIRL" },
  { value: "EARL", label: "EARL" },
  { value: "EURL", label: "EURL" },
  { value: "SARL", label: "SARL" },
  { value: "SASU", label: "SASU" },
  { value: "SAS", label: "SAS" },
  { value: "SCI", label: "SCI" },
  { value: "SCM", label: "SCM" },
  { value: "SCCV", label: "SCCV" },
  { value: "LMNP", label: "LMNP" },
  { value: "GFA", label: "GFA" },
  { value: "SC", label: "SC" },
  { value: "SCP", label: "SCP" },
  { value: "SEL", label: "SEL" },
  { value: "SELARL", label: "SELARL" },
];

export const CIVILITE_OPTIONS = [
  { value: "Monsieur", label: "Monsieur" },
  { value: "Madame", label: "Madame" },
];

export const EFFECTIF_OPTIONS = [
  { value: "0", label: "-" },
  { value: "1 à 10", label: "1 à 10" },
  { value: "11 à 20", label: "11 à 20" },
  { value: "21 à 50", label: "21 à 50" },
  { value: "Plus de 50", label: "Plus de 50" },
];

export const ORGANISATION_COMPTABLE_OPTIONS = [
  { value: "Sous-traitance", label: "Sous-traitance" },
  { value: "Surveillance", label: "Surveillance" },
];

export const TYPE_EVALUATION_OPTIONS = [
  { value: "vos droits sociaux", label: "Droits sociaux" },
  { value: "votre fonds de commerce", label: "Fonds" },
];
